import React, { useEffect, useState } from 'react';

export interface ContentMasterProductThumbProps {
  imageUrl?: string | null;
  /** Use empty string for decorative images next to visible titles. */
  alt: string;
  className?: string;
}

/**
 * Product image or gray placeholder. Resets after URL change; hides broken images.
 */
export const ContentMasterProductThumb: React.FC<ContentMasterProductThumbProps> = ({
  imageUrl,
  alt,
  className,
}) => {
  const [failed, setFailed] = useState(false);
  const url = imageUrl?.trim() ?? '';
  const showImage = url.length > 0 && !failed;

  useEffect(() => {
    setFailed(false);
  }, [url]);

  const rootClass = ['content-master-product-thumb', className].filter(Boolean).join(' ');

  return (
    <div className={rootClass}>
      {showImage ? (
        <img src={url} alt={alt} loading="lazy" onError={() => setFailed(true)} />
      ) : null}
    </div>
  );
};
